import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FollowIconsComponent } from '@shared/shared/modules/card/components/follow-icons/follow-icons.component';

@Component({
  selector: 'ten-dummy-follow-button',
  template: `
    <div class="button" [class.following]="isActive">
      <ten-follow-icons [isActive]="isActive" [type]="'follow'"></ten-follow-icons>
      <div class="button__text">
        {{ (isActive ? 'Preferences:Following' : 'Preferences:FollowArtist') | translate }}
      </div>
    </div>
  `,
  styleUrls: ['./dummy-follow-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [FollowIconsComponent, TranslateModule],
})
export class DummyFollowButtonComponent {
  @Input() public isActive: boolean;
}
